import React from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import { DynamicThemeProvider, Loading, Snackbar } from '@guryou/html-components';
import { feelTheme } from '@guryou/html-theme';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ResetPasswordDeal from 'containers/ResetPasswordDeal';
import VerifyPassword from './modules/verify';
import { ConfirmationError, ConfirmationSuccess } from 'modules/confirmations/';
import { UserConfirmation } from 'modules/user';
import Widget from 'modules/widget';
import WidgetAuth from 'modules/widget/WidgetAuth';
import WidgetCalendar from 'modules/widget/WidgetCalendar';
import moment from 'moment-timezone';
import FeelMainLayout from 'layouts/FeelMainLayout';
import CustomerFlow from 'modules/customerFlow';
import LoginPage from 'components/LoginPage';
import { FeelPanelBrandingProvider } from 'components/FeelPanelBrandingContext';
import FeelPrimaryPaletteSync from 'components/FeelPrimaryPaletteSync';
import WidgetIntegrationBrandingSync from 'components/WidgetIntegrationBrandingSync';
import UserLanguageSync from 'components/UserLanguageSync';
import { readFeelThemePrimaryFromSession } from 'constants/widgetIntegrationBranding';
import PrivateRoute from './ProtectedRoute';
import SuccessPage from 'modules/inviteFlow/SuccessPage';

const GlobalLoading = () => {
  const { pathname } = useLocation();

  if (pathname.startsWith('/website-integration-auth/') || pathname.startsWith('/website-integration-calendar/')) {
    return null;
  }

  return <Loading />;
};

const App = () => {
  return (
    <DynamicThemeProvider theme={feelTheme} getInitialMainColor={readFeelThemePrimaryFromSession}>
      <CssBaseline />
      <Snackbar
        maxSnack={2}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Router>
            <GlobalLoading />
            <FeelPanelBrandingProvider>
              <FeelPrimaryPaletteSync />
              <WidgetIntegrationBrandingSync />
              <UserLanguageSync />
              <Switch>
                <Route path={`/verify/:email/:code`} component={VerifyPassword} />
                <Route path="/reset/:email/:code" component={ResetPasswordDeal} libInstance={moment} />
                <Route path="/user-confirmation/:code" component={UserConfirmation} />
                <Route path="/reservation-success" component={() => <ConfirmationSuccess type="reservation" />} />
                <Route path="/subscription-success" component={() => <ConfirmationSuccess type="subscription" />} />
                <Route path="/reservation-confirmation-error" component={() => <ConfirmationError type="reservation" />} />
                <Route path="/subscription-confirmation-error" component={() => <ConfirmationError type="subscription" />} />
                <Route path="/website-integration-auth/:integrationId" component={WidgetAuth} />
                <Route path="/website-integration-calendar/:integrationId" component={WidgetCalendar} />
                <Route path="/website-integration/:integrationId" component={Widget} />
                <Route path="/successFlow" component={SuccessPage} />
                <PrivateRoute path="/customer-flow/:customerFlowId" component={CustomerFlow} />
                <Route path="/login" component={LoginPage} />
                <Route path="/" component={FeelMainLayout} />
                {/* <Route path="/" component={() => (window.location = process.env.REACT_APP_NEXTJS_URL)} /> */}
              </Switch>
            </FeelPanelBrandingProvider>
          </Router>
        </MuiPickersUtilsProvider>
      </Snackbar>
    </DynamicThemeProvider>
  );
};
export default App;
